<template>
  <el-dialog
    v-el-drag-dialog
    :title="$t('CargoMsg.Cargo_BatchUpdateExchangeRate')"
    :close-on-click-modal="false"
    :visible.sync="innerVisible"
    width="400px"
    @close="cancel"
  >
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form :inline="true" label-width="70px" label-position="left" @submit.native.prevent>
        <el-card style="width: 100%">
          <div style="margin-top: 10px;">
            <span>{{ $t('CargoMsg.Cargo_SelectAccountAndCurrency') }}</span>
            <el-form-item :label="$t('Payment.settleAccountsTo')" style="margin-top: 10px;margin-left: 20px;">
              <cargo-advance-select
                no="settleAccountsTo"
                filterable
                style="width: 200px;"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{ active: true }"
                :check-credit="true"
                :default-value="accountId"
                :tag-value="accountId"
                @parentCallBack="p => { this.accountId = p.value }"
              />
            </el-form-item>
            <el-form-item :label="$t('Invoice.invoice_currency')" style="margin-top: 10px;margin-left: 20px;" required>
              <cargo-advance-select
                no="invoice_currency"
                style="width: 200px;"
                filterable
                :select-type="selectTypeNames.basic_data_Currency"
                :default-value="currency"
                :clearable="false"
                @parentCallBack="p => { this.currency = p.value }"
              />
            </el-form-item>
          </div>
        </el-card>
        <el-card style="width: 100%;margin-top: 30px;">
          <div style="flex: 1">
            <span>{{ $t('CargoMsg.Cargo_InputRate') }}</span>
            <el-form-item :label="$t('Payment.exchangeRate')" style="margin-top: 10px;margin-left: 20px;">
              <num-input
                v-model="exchangeRate"
                no="exchangeRate"
                :precision="8"
                :truncated-precision="exchangeRatePrecision"
                :min="0"
                :max="999999999999"
                style="width: 200px;"
              />
            </el-form-item>
          </div>
        </el-card>
      </el-form>
    </div>
    <div slot="footer">
      <el-button no="confirm" type="primary" size="mini" @click="confirm">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button no="cancel" size="mini" @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { updateExchangeRate, validateForUpdateExchangeRate } from '@/api/clearing/charge'
import { cache, cacheName } from '@/utils/cacheManager'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'

export default {
  name: 'UpdateExchangeRateDialog',
  components: { cargoAdvanceSelect, NumInput },
  props: {
    visible: { type: Boolean, required: true },
    jobKeyList: { type: Array, required: true },
    location: { type: String, required: false }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      accountId: '',
      currency: '',
      // CARGO-28423 批量修改汇率需要支持对已经锁定的业务或者费用进行更改
      isUpdateAllCostRates: false,
      exchangeRate: '',
      loading: null
    }
  },
  computed: {
    exchangeRatePrecision() {
      return CurrencyUtil.getCurrencyRateDigits(this.currency)
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.accountId = ''
      this.currency = ''
      this.exchangeRate = ''
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.initConfig()
  },
  methods: {
    // 配置参数
    initConfig() {
      this.isUpdateAllCostRates = Number(cache.config.get('updateAllCostRates')) === 1
    },
    async confirm() {
      if (!this.currency) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectCurrency'))
        return
      }
      if (!this.exchangeRate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseInputRate'))
        return
      }
      this.loading = getLoading()
      const chargeKeys = []
      if (!this.accountId) {
        this.accountId = 0
      }
      validateForUpdateExchangeRate({ 'jobKeys': this.jobKeyList, 'accountId': this.accountId, 'currency': this.currency, 'officeId': this.$store.getters.currentOfficeId }).then(async res => {
        this.loading.close()
        if (!res.data || res.data.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ValidateUpdateRateTips'))
          return
        } else {
          const tipsMsgList = []
          for (const item of res.data) {
            // 检查费用已生成的项目
            if (this.isUpdateAllCostRates) {
              // 核销
              if (tipsMsgList.indexOf(this.$t('CargoMsg.Cargo_Verification')) < 0 && Number(item.chargeHasVerified) > 0) {
                tipsMsgList.push(this.$t('CargoMsg.Cargo_Verification'))
              }
              // 账单
              if (tipsMsgList.indexOf(this.$t('CargoMsg.Cargo_Bill')) < 0 && Number(item.chargeHasBilling) > 0) {
                tipsMsgList.push(this.$t('CargoMsg.Cargo_Bill'))
              }
              // 开票
              if (tipsMsgList.indexOf(this.$t('CargoMsg.Cargo_Invoicing')) < 0 && Number(item.chargeHasInvoice) > 0) {
                tipsMsgList.push(this.$t('CargoMsg.Cargo_Invoicing'))
              }
              // 付款申请
              if (tipsMsgList.indexOf(this.$t('CargoMsg.Cargo_PaymentRequest')) < 0 && Number(item.chargeHasBillPayment) > 0) {
                tipsMsgList.push(this.$t('CargoMsg.Cargo_PaymentRequest'))
              }
              // 对账单
              if (tipsMsgList.indexOf(this.$t('CargoMsg.Cargo_AccountStatement')) < 0 && Number(item.chargeHasBillingGroup) > 0) {
                tipsMsgList.push(this.$t('CargoMsg.Cargo_AccountStatement'))
              }
              // 凭证
              if (tipsMsgList.indexOf(this.$t('CargoMsg.Cargo_Proof')) < 0 && Number(item.chargeHasAccountDocument) > 0) {
                tipsMsgList.push(this.$t('CargoMsg.Cargo_Proof'))
              }
            }
            chargeKeys.push(item.chargeUuid)
          }
          const hasInvalidCharge = tipsMsgList.length > 0
          let tips = ''
          if (hasInvalidCharge) {
            // 根据已生成的项目拼接提示信息
            tips = this.$t('CargoMsg.Cargo_UpdateRateConfirmTipsHead')
            tips += tipsMsgList.join(',')
            tips += this.$t('CargoMsg.Cargo_UpdateRateConfirmTipsTail')
          }
          this.updateExchangeRate(chargeKeys, hasInvalidCharge, tips)
        }
      }).finally(() => {
        if (this.loading) {
          this.loading.close()
        }
      })
    },
    updateExchangeRate(chargeKeys, hasInvalidCharge, tips) {
      this.$confirm(hasInvalidCharge ? tips : this.$t('CargoMsg.Cargo_ConfirmUpdateExchangeRate'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        if (!this.accountId) {
          this.accountId = 0
        }
        updateExchangeRate({ 'chargeKeys': chargeKeys, 'accountId': this.accountId, 'currency': this.currency, 'exchangeRate': this.exchangeRate, 'location': this.location }).then(() => {
          this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
          this.innerVisible = false
        }).finally(() => {
          if (this.loading) {
            this.loading.close()
          }
        })
      })
    },
    cancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss">
</style>
